import { useCart } from "./CartContext";

export default function CartItem({ item }) {
  const { updateQuantity, removeFromCart } = useCart();

  return (
    <div className="cart-item">
      <img src={item.imageUrl} alt={item.UITitle} />
      <h3>{item.UITitle} • ${item.price.toFixed(2)}</h3>

      {/* Quantity Counter */}
      <div>
        <label>Quantity:</label>
          <div >
            <button onClick={() => updateQuantity(item.id, item.quantity - 1)} disabled={item.quantity <= 1}>-</button>
            <span className="cart-quantity">{item.quantity}</span>
            <button onClick={() => updateQuantity(item.id, item.quantity + 1)}>+</button>
          </div>
      </div>
      <button className="remove-btn" onClick={() => removeFromCart(item.id)}>
        Remove Item
      </button>
    </div>
  );
}